import { useState, useEffect } from "react";
import Page from "../components/Page";
import Loader from "../components/Loader/Loader";
import HomeSection from "../components/HomeSection";
import useLogin from "../custom-hooks/useLogin";
import GuestHomePageComponent from "../components/NewDesign/HomePage/GuestHomePage/GuestHomePageComponent";
import { SessionKeys } from "../utils/AppUtils";
import { useSelector } from "react-redux";
import CustomerHomePageComponent from "../components/NewDesign/HomePage/CustomerHomePage/CustomerHomePageComponent";
import RecommendationEnginePage from "./B2C-Pages/RecommendationEnginePage";
import { useDispatch } from "react-redux";
import { getActiveHeader, getActiveHeaderClear } from "../redux/home/actions";

const HomePage = (props, id) => {
  const [isLoading, setIsLoading] = useState(false);
  let dispatch = useDispatch();
  const userRole = useSelector((state) => state.user.role);
  console.log("test----", userRole);
  const { isLoggedIn } = useLogin();
 
  const renderHomeSection = () => {
    if (userRole === "customer") {
      return (
        <>
          <CustomerHomePageComponent
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          <RecommendationEnginePage />
        </>
      );
    } else if (
      userRole === "realtor" ||
      userRole === "manager" ||
      userRole === "host" ||
      userRole === "instructor"
    ) {
      return (
        <>
          <HomeSection isLoading={isLoading} setIsLoading={setIsLoading} />
          {userRole === "instructor" || userRole === "host" ? " " : <RecommendationEnginePage /> }
        </>
      );
    }
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // Adjust the timing as needed
    dispatch(getActiveHeader("home"));
  
  }, []);

  return (
    <>
      <Loader start={isLoading} />
      <Page>
        {isLoggedIn || localStorage.getItem(SessionKeys.API_TOKEN_BROKER) ? (
          renderHomeSection()
        ) : (
          <GuestHomePageComponent
            fetchData={true}
            setMainPageLoading={setIsLoading}
          />
        )}
      </Page>
    </>
  );
};

export default HomePage;
